import React, {useCallback, useRef, useState} from 'react';
import { classNames, sashClassName } from './base';
import { ISashProps } from './types';


export default function Sash({
    className,
    render,
    onDragStart,
    onDragging,
    onDragEnd,
    ...others
}: ISashProps) {
    const timeout = useRef<number | null>(null);
    const [active, setActive] = useState(false);
    const [draging, setDrag] = useState(false);
    const lastTouch = useRef(null);

    const handleMouseMove = function (e: any) {
        onDragging(e);
    };

    const handleMouseUp = function (e: any) {
        setDrag(false);
        onDragEnd(e);
        window.removeEventListener('mousemove', handleMouseMove);
        window.removeEventListener('mouseup', handleMouseUp);
        document.body.style.userSelect = '';
    };

    const handleTouchMove = function (e: any) {
        onDragging(e.touches[0]);
        lastTouch.current = e.touches[0];
    }

    const handleTouchUp = function (e: any) {
        window.removeEventListener('touchmove', handleTouchMove);
        window.removeEventListener('touchend', handleTouchUp);
        setDrag(false);
        onDragEnd(lastTouch.current!);
    }

    return (
        <div
            role="Resizer"
            className={classNames(
                sashClassName,
                className
            )}
            onMouseEnter={() => {
                (timeout.current as any) = setTimeout(() => {
                    setActive(true);
                }, 150);
            }}
            onMouseLeave={() => {
                if (timeout.current) {
                    setActive(false);
                    clearTimeout(timeout.current);
                }
            }}
            onMouseDown={e => {
                e.preventDefault();
                setDrag(true);
                onDragStart(e);
                document.body.style.userSelect = 'none';

                window.addEventListener('mousemove', handleMouseMove);
                window.addEventListener('mouseup', handleMouseUp);
            }}
            onTouchStart={e => {
                setDrag(true);
                (lastTouch.current as any) = e.touches[0];
                onDragStart(e.touches[0] as any);

                window.addEventListener('touchmove', handleTouchMove);
                window.addEventListener('touchend', handleTouchUp);
            }}
            {...others}
        >
            {render(draging || active) as any}
        </div>
    );
}
